const SIDEBAR_WIDTH = '263px';

const CATEGORY_KEY = 'automationCategories';

const POPULAR_KEY = 'popular';

export { SIDEBAR_WIDTH, CATEGORY_KEY, POPULAR_KEY };
